<div id="navigator">
    <div id="navInner" class="ui-widget ui-widget-content"></div>
</div>